import { render, staticRenderFns } from "./sharing.svg.vue?vue&type=template&id=1ec1d601"
import script from "./sharing.svg.vue?vue&type=script&lang=ts"
export * from "./sharing.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ec1d601')) {
      api.createRecord('1ec1d601', component.options)
    } else {
      api.reload('1ec1d601', component.options)
    }
    module.hot.accept("./sharing.svg.vue?vue&type=template&id=1ec1d601", function () {
      api.rerender('1ec1d601', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/landing/LandingContentBox/sharing.svg.vue"
export default component.exports